<template>
  <div style="height:100%;width: 100%">
    <form id="queryReport" style="display:none" name="form" target="dictPrint">
      <table>
        <tr>
          <td id="report_td">
            <input id="reportlet" name="reportlet"/>
          </td>
        </tr>
      </table>
    </form>
    <iframe style="width: 100%;height: 100%" id="reportIframe" frameborder="1"   name="dictPrint" width="100%"></iframe>
  </div>
</template>


<script>
import { queryReportMessage,queryReportLoginUrl } from '@/api/common';
export default {
  name: 'reportShow',
  data () {
    return {
      msg: "打印预览",
      preParams:[],
      queryParams: {},
    }
  },
  methods: {
    //初始化方法
    init(){
      let self=this;
      let params = {};
      return new Promise(resolve => {
        //从后台获取url和token这些
        queryReportMessage(params).then(res => {
          if(res.success){
            let mdReportMessage=res.mdReportMessage;
            let orgId = mdReportMessage.orgId;
            let resultData = mdReportMessage.safeFlag;
            self.virtualLoginAndPreview(mdReportMessage.loginUrl, mdReportMessage.previewUrl, mdReportMessage.printUrl, res.token,mdReportMessage.ipAddress);
          }
        });
      }).catch(err => {
        console.log(err);
      });
    },
    virtualLoginAndPreview(checkLoginUrl, previewUrl, printUrl, token,ipAddress){

      /* axios.get(checkLoginUrl, { // 这里会匹配到前面我们设置的/proxy，代替为https://www.tianqiapi.com
         headers: {
           "Access-Control-Allow-Origin": "*",
           "Access-Control-Allow-Credentials":"true"
         },
       }).then(function (response) {
         console.log(response)
       }).catch(function (error) {
         console.log(error)
       })*/
      return new Promise(resolve => {
        let Params={
          baseViewId: "undefined",
          primaryId: this.$route.query.primaryId,
          reportlet: this.$route.query.reportUrl,
          systemType: this.$route.query.systemType
        };
        for (let key of Object.keys(this.$route.query)) {
          Params[key] = this.$route.query[key];
        }
        //地址要做一下代理转换
        //登录帆软服务器
        queryReportLoginUrl(checkLoginUrl).then(res => {
          if(res!=undefined){
            let reportletId=document.getElementById("reportlet");
            for (let key in Params) {
              if (key == "reportlet") {
                let reportCptUrl = Params[key];
                let reportEnv = 'cts_test';
                if (reportEnv && reportEnv != "undefined") {
                  reportCptUrl = reportCptUrl.replace("cts/", reportEnv + "/");
                }
                reportletId.value = reportCptUrl;
              } else {
                reportletId.insertAdjacentHTML('afterend', "<input name='" + key + "' value='" + Params[key] + "' />");
              }
            }
            ;
            reportletId.insertAdjacentHTML('afterend', "<input name='token' value='" + token + "' />");
            reportletId.insertAdjacentHTML('afterend', "<input name='ipAddress' value='" + ipAddress + "' />");
            document.getElementById("queryReport").action=previewUrl;
            document.getElementById("queryReport").submit();
          }

        });
      }).catch(err => {
        console.log(err);
        return self.$coreMethods.confirm(null,null,true,"连接报表服务器失败","提示","error");
      });

    }
  },
  created() {
    this.init();
  },
}
</script>
